/**
 * Extracts a readable error message from API error responses
 * Handles Pydantic validation errors, string errors, and generic errors
 */
export const extractErrorMessage = (err: any): string => {
  if (err.response?.data) {
    const errorData = err.response.data;

    // Handle array of validation errors (Pydantic validation errors)
    if (Array.isArray(errorData.detail)) {
      return errorData.detail
        .map((error: any) => error.msg || error.message || 'Erreur de validation')
        .join(', ');
    }

    // Handle string error detail
    if (typeof errorData.detail === 'string') {
      return errorData.detail;
    }

    // Handle message field
    if (errorData.message) {
      return errorData.message;
    }
  }

  // Handle network errors
  if (err.message) {
    return err.message;
  }

  return 'Une erreur est survenue';
};
